module.exports = __webpack_public_path__ + "static/avatar-0b2541de03d0a9d63fead79989fc94ee.jpg";